<template>
  <select
    class="lang"
    v-model="languageCode"
    v-on:change="modLang"
  >
    <option v-for="(language, index) in languages" v-bind:key="index" v-bind:value="language.value">{{ language.text }}</option>
  </select>
</template>

<script>
import { defaultLanguage, language } from '@/utils/language'

export default {
  name: 'SelectLanguage',
  data: function () {
    return {
      languageCode: this.$route.params.languageCode ? this.$route.params.languageCode : localStorage.getItem('lang') ? localStorage.getItem('lang') : defaultLanguage(),
      languages: language()
    }
  },
  mounted: function () {
    this.$i18n.locale = this.languageCode;
    localStorage.setItem('lang', this.languageCode)
  },
  methods: {
    modLang: function () {
      this.$i18n.locale = this.languageCode;
      localStorage.setItem('lang', this.languageCode)
      let path = this.$router.currentRoute.fullPath
      if( ~path.indexOf('/login') ){
        let splitPath = path.split('/')
        let url = '/' + this.languageCode + '/' + splitPath.slice(-1)[0]
        this.$router.push(url)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.lang {
  width: auto;
  height: auto;
  float: right;
}
</style>
